import {showNotification} from 'platform/components';
import {Show} from 'platform/foundation';

import {useGetMobileDePlatformQuery, useMobileDeAuthenticateMutation} from '@dms/api/sales';
import {AdvertisingPlatformCodeEnum} from '@dms/api/shared';
import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {useBranchId} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {
  PlatformAuthenticationFormMobileDe,
  PlatformAuthenticationFormMobileDeProps,
} from './components/PlatformAuthenticationFormMobileDe';
import {PlatformPhotoSettings} from './components/PlatformPhotoSettings';
import {PlatformSettingsPromptBridge} from './PlatformSettingsPromptBridge';

export function PlatformSettingsMobileDe() {
  return (
    <>
      <Show whenFeatureEnabled={featureFlags.ADVERTISEMENT_MOBILE_DE_PROMPT_BRIDGE}>
        <PlatformSettingsPromptBridge code={AdvertisingPlatformCodeEnum.MOBILE_DE} />
      </Show>
      <Show whenFeatureDisabled={featureFlags.ADVERTISEMENT_MOBILE_DE_PROMPT_BRIDGE}>
        <PlatformCredentialsMobileDeLegacy />
      </Show>
      <PlatformPhotoSettings platformCode={AdvertisingPlatformCodeEnum.MOBILE_DE} />
    </>
  );
}

function PlatformCredentialsMobileDeLegacy() {
  const branchId = useBranchId();
  const params = {branchId};
  const {data, isFetching, isError} = useGetMobileDePlatformQuery({params});
  const [saveAuthentication] = useMobileDeAuthenticateMutation();

  const onSubmitCredentials: PlatformAuthenticationFormMobileDeProps['onSubmit'] = (
    values,
    _setErrors,
    reset
  ) =>
    saveAuthentication({body: values, params})
      .unwrap()
      .then(() => {
        showNotification.success(
          i18n.t('entity.advertisingPlatforms.notifications.credentialsSaved')
        );
        reset(undefined, {keepValues: true});
      })
      .catch(handleApiError);

  return (
    <PlatformAuthenticationFormMobileDe
      values={data?.credentials}
      isFetching={isFetching}
      isError={isError}
      onSubmit={onSubmitCredentials}
    />
  );
}
